import {
  configureReportingTrialDevOverrides,
  type ReportingTrialState,
} from '@cast/shared-trial-ui';
import { ReportingMonetizationTierEnum } from '@cast/types';

import {
  createBooleanOverride,
  createDropdownOverride,
} from 'core/dev-toolbox';

const REPORTING_TRIAL_STATES: ReportingTrialState[] = [
  'pre-trial',
  'active',
  'grace-period',
  'post-trial',
  'paid',
];

const REPORTING_TIERS = [
  ReportingMonetizationTierEnum.STARTER,
  ReportingMonetizationTierEnum.TEAM,
  ReportingMonetizationTierEnum.PREMIUM,
] as const;

const useReportingTrialStateOverride =
  createDropdownOverride<ReportingTrialState>(
    'reportingTrialState',
    REPORTING_TRIAL_STATES,
    { group: 'reportingTrial' }
  );

const useReportingTrialEligibleOverride = createBooleanOverride(
  'reportingTrialEligible',
  { group: 'reportingTrial' }
);

const useReportingTrialTierOverride = createDropdownOverride(
  'reportingTrialTier',
  [...REPORTING_TIERS],
  { group: 'reportingTrial' }
);

configureReportingTrialDevOverrides({
  useReportingTrialStateOverride,
  useReportingTrialEligibleOverride,
  useReportingTrialTierOverride,
});
